import React, {PropsWithChildren} from 'react';

const style = {
	outerContainer: `absolute top-36 recommended:top-44   flex   w-full min-h-[calc(100vh-9rem)] recommended:min-h-[calc(100vh-11rem)]`,
	innerContainer: `flex flex-col gap-y-20   px-1 py-10 recommended:px-10 recommended:py-20   w-full max-h-[calc(100vh-9rem)] recommended:max-h-[calc(100vh-11rem)]   bg-whirlwindDark   overflow-auto   scrollbar-webkit`,
};

export const Page = ({children}: PropsWithChildren) => {
	return (
		<div className={style.outerContainer}>
			<div className={style.innerContainer}>{children}</div>
		</div>
	);
};
